import styled from 'styled-components';

export const StyledForgotPasswordModal = styled.div`
  .fpm-wrapper {
    padding: 20px 28px 0;

    > p {
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      text-align: left;
      margin-bottom: 18px;
    }

    &-content {
      height: auto;

      > div {
        &:first-child {
          margin-bottom: 16px;
        }
      }
    }

    input[type='number']::-webkit-outer-spin-button,
    input[type='number']::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type='number'] {
      -moz-appearance: textfield;
    }
  }
`;
